import React from 'react';
import { LuFacebook, LuInstagram, LuTwitter, LuMessageCircle } from 'react-icons/lu';
import { FaTelegramPlane, FaViber, FaWhatsapp } from 'react-icons/fa';
import { Button, Container } from 'react-bootstrap';

export default function SocialShareBar() {
  const shareUrl = window.location.href;
  const shareText = "Plămânul Verde al Orașului – PRDP propune un parc urban multifuncțional ce creează locuri de muncă, sprijină familiile, atrage turiști și susține economia locală, pentru un oraș mai curat și sustenabil.";

  const socialLinks = [
    {
      name: 'Facebook',
      icon: LuFacebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      color: '#1877F2'
    },
    {
      name: 'Instagram',
      icon: LuInstagram,
      url: `https://www.instagram.com/partidulprdp/`,
      color: '#E4405F'
    },
    {
      name: 'Twitter',
      icon: LuTwitter,
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
      color: '#1DA1F2'
    },
    {
      name: 'WhatsApp',
      icon: FaWhatsapp,
      url: `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`,
      color: '#25D366'
    },
    {
      name: 'Telegram',
      icon: FaTelegramPlane,
      url: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
      color: '#229ED9'
    },
    {
        name: 'Viber',
        icon: FaViber,
        url: `viber://forward?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`,
        color: '#665CAC'
    }
  ];

  const handleShare = (url) => {
    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <div style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
      <Container className="py-3 d-flex flex-column flex-md-row align-items-center justify-content-between">
        <h6 className="fw-bold mb-2 mb-md-0" style={{ color: "#143685", fontSize: 15 }}>
          Distribuie proiectul „Plămânul Verde al Orașului”:
        </h6>
        <div className="d-flex gap-2">
          {socialLinks.map(({ name, icon: Icon, url, color }) => (
            <Button
              key={name}
              onClick={() => handleShare(url)}
              variant="light"
              className="d-flex align-items-center justify-content-center border-0"
              style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px #e7eaf1",
                padding: 10,
                width: 40,
                height: 40
              }}
              title={`Distribuie pe ${name}`}
            >
              <Icon size={18} style={{ color }} />
            </Button>
          ))}
        </div>
      </Container>
    </div>
  );
}
